__turbopack_context__.v({
  "content": "CampaignHero-module-scss-module__obaDdG__content",
  "copy": "CampaignHero-module-scss-module__obaDdG__copy",
  "cta": "CampaignHero-module-scss-module__obaDdG__cta",
  "ctaRow": "CampaignHero-module-scss-module__obaDdG__ctaRow",
  "flipped": "CampaignHero-module-scss-module__obaDdG__flipped",
  "hero": "CampaignHero-module-scss-module__obaDdG__hero",
  "image": "CampaignHero-module-scss-module__obaDdG__image",
  "infoCard": "CampaignHero-module-scss-module__obaDdG__infoCard",
  "media": "CampaignHero-module-scss-module__obaDdG__media",
  "overlay": "CampaignHero-module-scss-module__obaDdG__overlay",
  "sideBySide": "CampaignHero-module-scss-module__obaDdG__sideBySide",
  "subheading": "CampaignHero-module-scss-module__obaDdG__subheading",
  "title": "CampaignHero-module-scss-module__obaDdG__title",
});
